import styles from "./styles.module.css";

type Props = {
  listTitle: string[];
  lastPage: number;
  setPage: Function;
  atualPage: number;
  styleList?: number[];
  paginacao?: boolean;
  children: any;
};

const TabelaPaginacao = ({
  listTitle,
  lastPage,
  setPage,
  atualPage,
  styleList,
  paginacao,
  children,
}: Props) => {
  let lista = [];

  for (let index = 1; index <= lastPage; index++) {
    lista.push(index);
  }

  const selectStyle = (id: number) => {
    switch (styleList ? styleList[id] : 0) {
      case 1:
        return styles.thcenter;

      default:
        return "";
    }
  };

  return (
    <>
      <table className={styles.tabela}>
        <tbody>
          <tr className={styles.header}>
            {listTitle.map((colTitle: string, index) => (
              <th key={index} className={selectStyle(index)}>
                {colTitle}
              </th>
            ))}
          </tr>

          {children}
        </tbody>
      </table>

      {paginacao && (
        <div className={styles.btnRow}>
          {atualPage > 1 && (
            <button
              onClick={() => {
                setPage(atualPage - 1);
              }}
            >
              ❮
            </button>
          )}

          {lista.map((pagina) => (
            <button
              className={pagina === atualPage ? styles.activeBtn : ""}
              key={pagina}
              onClick={() => {
                setPage(pagina);
              }}
            >
              {pagina}
            </button>
          ))}

          {atualPage < lastPage && (
            <button
              onClick={() => {
                setPage(atualPage + 1);
              }}
            >
              ❯
            </button>
          )}
        </div>
      )}
    </>
  );
};
export default TabelaPaginacao;
